export default "__VITE_ASSET__yJZjgUKT__"